import { AnyAction } from "redux";
import * as actionsProj from "../Actions/Projects";

export interface IProject {
  // beneficiary: string;
  // beneficiaryForeignNumber?: string; //TODO: to be removed after correction in all components
  beneficiaryIdentityNumber?: string;
  beneficiaryIdentityType?: string;
  beneficiaryName?: string;
  // beneficiaryNIP: string; //TODO: to be removed after correction in all components
  // beneficiaryPESEL?: string; //TODO: to be removed after correction in all components
  beneficiaryAddress?: string;
  name: string;
  number: string;
  title: string
  implementationLevel: string
  projectId: string;
  externalId?: string
  uuid?: string;
  metadata: ProjectMetadata;
  metaUUID?: string;
}

export interface IProjectsState {
    projects?: IProject[]
    isLoading?: boolean
    isError?: boolean
    error?: object
    totalElements?: number;
}

export interface ProjectMetadata {
  businessId: string;
}


export const projectsReducer = (state: IProjectsState = {}, action: AnyAction) => {
  switch (action.type) {
    case actionsProj.GET_PROJECTS_DATA_REQUESTED:
      return { ...state, isLoading: true };
    case actionsProj.GET_PROJECTS_DATA_DONE:
      return { ...state, isLoading: false, totalElements: action.payload.totalElements, projects: action.payload.projects.map( (project: IProject) => {
        return {
          ...project,
          projectId: project.externalId
        }
      }) };
    case actionsProj.GET_PROJECTS_DATA_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    case actionsProj.GET_ALL_PROJECTS_DATA_REQUESTED:
        return { ...state, isLoading: true };
    case actionsProj.GET_ALL_PROJECTS_DATA_DONE:
        return { ...state, isLoading: false, projects: action.payload.map( (project: IProject) => {
          return {
            ...project,
            projectId: project.externalId
          }
        }) };
    case actionsProj.GET_ALL_PROJECTS_DATA_FAILED:
        return {
          ...state,
          isLoading: false,
          isError: true,
          error: action.payload,
        };
    default:
      return state;
  }
};
